function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var UtxoTemplate = require('./utxo.template');
var _require = require('../explorer-format'),
  formatSaito = _require.formatSaito,
  buildPublicKeyLink = _require.buildPublicKeyLink;
var _require2 = require('../utxo-key'),
  normalizeUtxoKeyHex = _require2.normalizeUtxoKeyHex,
  parseUtxoKeyHex = _require2.parseUtxoKeyHex;
var _require3 = require('../transaction-types'),
  formatSlipTypeName = _require3.formatSlipTypeName;
var Utxo = /*#__PURE__*/function () {
  function Utxo(app, mod, utxokey) {
    _classCallCheck(this, Utxo);
    this.app = app;
    this.mod = mod;
    this.utxokey = normalizeUtxoKeyHex(utxokey);
    this.container = '.explorer-view';
  }
  return _createClass(Utxo, [{
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      this.mod.utxoComponent = this;
      this.paint();
      if (!this.mod.utxoReady && this.mod.explorerPeer) {
        this.mod.fetchUtxoData(this.app, this.mod.explorerPeer, this.utxokey);
      }
    }
  }, {
    key: "formatSlip",
    value: function formatSlip(slip) {
      var _this$app, _slip$blockId, _ref, _slip$transactionId, _slip$slipIndex;
      if (!slip) {
        return null;
      }
      var rawPublicKey = slip.publicKey || slip.publicKeyHex || '';
      var publicKey = rawPublicKey;
      if (/^[0-9a-fA-F]{66}$/.test(rawPublicKey) && (_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.crypto) !== null && _this$app !== void 0 && _this$app.toBase58) {
        try {
          publicKey = this.app.crypto.toBase58(rawPublicKey);
        } catch (err) {
          publicKey = rawPublicKey;
        }
      }
      var blockId = String((_slip$blockId = slip.blockId) !== null && _slip$blockId !== void 0 ? _slip$blockId : '');
      var canVisitBlock = /^[1-9][0-9]*$/.test(blockId);
      var typeName = String(slip.type || slip.slipTypeName || formatSlipTypeName(slip.typeId) || '');
      var amountRaw = slip.amount != null ? String(slip.amount) : '';
      var amountDisplay = amountRaw || '—';
      try {
        var amount = BigInt(amountRaw || 0);
        if (typeName === 'Bound') {
          amountDisplay = amount === 0n ? '0 (not SAITO)' : "".concat(amount.toLocaleString('en-US'), " units");
        } else {
          amountDisplay = formatSaito(amount);
        }
      } catch (err) {
        amountDisplay = amountRaw || '—';
      }
      return {
        type: this.app.browser.escapeHTML(typeName),
        blockId: this.app.browser.escapeHTML(blockId),
        blockHref: canVisitBlock ? "/explorer/block/".concat(encodeURIComponent(blockId)) : '',
        blockInput: canVisitBlock ? this.app.browser.escapeHTML(blockId) : '',
        transactionId: this.app.browser.escapeHTML(String((_ref = (_slip$transactionId = slip.transactionId) !== null && _slip$transactionId !== void 0 ? _slip$transactionId : slip.txOrdinal) !== null && _ref !== void 0 ? _ref : '')),
        slipIndex: this.app.browser.escapeHTML(String((_slip$slipIndex = slip.slipIndex) !== null && _slip$slipIndex !== void 0 ? _slip$slipIndex : '')),
        publicKey: buildPublicKeyLink(this.app, publicKey, publicKey),
        amountDisplay: this.app.browser.escapeHTML(amountDisplay)
      };
    }
  }, {
    key: "paint",
    value: function paint() {
      var loading = !this.mod.utxoReady;
      var error = this.mod.utxoError ? this.app.browser.escapeHTML(this.mod.utxoError) : null;
      var result = this.mod.utxoResult || {};
      var parsed = parseUtxoKeyHex(this.utxokey);
      var localSlip = parsed ? {
        type: parsed.slipTypeName,
        blockId: parsed.blockId.toString(),
        transactionId: parsed.txOrdinal.toString(),
        slipIndex: String(parsed.slipIndex),
        publicKeyHex: parsed.publicKeyHex,
        amount: parsed.amount.toString()
      } : null;
      this.app.browser.replaceElementContentBySelector(UtxoTemplate({
        loading: loading,
        error: error,
        utxokey: this.app.browser.escapeHTML(this.utxokey),
        status: this.app.browser.escapeHTML(String(result.status || '')),
        slip: this.formatSlip(result.slip || localSlip)
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('.explorer-utxo-block-link').forEach(function (link) {
        link.onclick = function (event) {
          event.preventDefault();
          var input = link.getAttribute('data-block-input');
          if (input) {
            _this.mod.renderBlock(input, {
              pushState: true,
              animate: true
            });
          }
        };
      });
    }
  }]);
}();
module.exports = Utxo;